import { render, staticRenderFns } from "./Postgres.vue?vue&type=template&id=889ea234&"
import script from "./Postgres.vue?vue&type=script&lang=js&"
export * from "./Postgres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('889ea234')) {
      api.createRecord('889ea234', component.options)
    } else {
      api.reload('889ea234', component.options)
    }
    module.hot.accept("./Postgres.vue?vue&type=template&id=889ea234&", function () {
      api.rerender('889ea234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/products/Postgres.vue"
export default component.exports